module.exports = __webpack_public_path__ + "static/media/A Dance Under the Stars.135d3c01.jpg";